import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import styles from './HpRespPersonalizationPanelMainItem.scss';

function HpRespPersonalizationPanelMainItem({
    item,
    categoryUrl,
    categoryTitle,
    onItemClick,
    onViewAllClick,
    index,
}) {
    const dataTnHeader = `recommended-type-header-${index + 1}`;
    const dataTnLink = `recommended-type-link-${index + 1}`;
    return (
        <div className={styles.container}>
            <div className={`h1 ${styles.title}`} data-tn={dataTnHeader}>
                {categoryTitle}
            </div>
            <a className={styles.imageContainer} href={categoryUrl} onClick={onItemClick}>
                <img alt={item.title} className={styles.image} src={item.mainImage.medium} />
            </a>
            <a
                href={categoryUrl}
                className={styles.viewAll}
                data-tn={dataTnLink}
                onClick={onViewAllClick}
            >
                <FormattedMessage
                    id="homepage.modules.personalization.viewAll"
                    defaultMessage="View All"
                />
            </a>
        </div>
    );
}

HpRespPersonalizationPanelMainItem.propTypes = {
    item: PropTypes.object.isRequired,
    categoryUrl: PropTypes.string.isRequired,
    categoryTitle: PropTypes.string.isRequired,
    onItemClick: PropTypes.func,
    onViewAllClick: PropTypes.func,
    index: PropTypes.number,
};

HpRespPersonalizationPanelMainItem.defaultProps = {
    onItemClick: () => {},
    onViewAllClick: () => {},
};

export { HpRespPersonalizationPanelMainItem };
